import { render } from "./DashboardBank.vue?vue&type=template&id=e104ccfa&scoped=true&ts=true"
import script from "./DashboardBank.vue?vue&type=script&lang=ts"
export * from "./DashboardBank.vue?vue&type=script&lang=ts"

import "./DashboardBank.vue?vue&type=style&index=0&id=e104ccfa&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e104ccfa"]])

export default __exports__